import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { ArrowUpRight } from "lucide-react";
import { API, useApp } from "../context/AppContext";

export function NewsletterBlock({ compact = false }) {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/newsletter`, { email });
      setDone(true);
      toast.success("You're on the list.");
    } catch {
      toast.error("Something went wrong. Try again.");
    }
  };
  return (
    <div data-testid="newsletter-block" className={compact ? "" : "card-line p-8 sm:p-12"}>
      <p className="eyebrow mb-3">Newsletter</p>
      <h3 className="font-display font-extrabold uppercase text-xl sm:text-2xl mb-2">Field Notes, Monthly</h3>
      <p className="text-sm text-muted-foreground mb-6 max-w-md">New works, exhibitions, RISE updates, and DATOS releases — straight to your inbox.</p>
      {done ? (
        <p className="font-display font-bold uppercase text-[#FF1A1A]" data-testid="newsletter-success">You're in. Watch your inbox.</p>
      ) : (
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3" data-testid="newsletter-form">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            data-testid="newsletter-email-input"
            className="input-x flex-1"
            aria-label="Email for newsletter"
          />
          <button type="submit" className="btn-red" data-testid="newsletter-submit">Subscribe</button>
        </form>
      )}
    </div>
  );
}

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border" data-testid="site-footer">
      <div className="container-x section-y grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-6">
            <span className="w-10 h-10 bg-[#FF1A1A] flex items-center justify-center font-display font-black text-white">AM</span>
            <span className="font-display font-extrabold uppercase text-lg">Atuarra McCaslin</span>
          </div>
          <p className="text-sm text-muted-foreground max-w-sm mb-8">
            Contemporary artist, curator, and founder — building a cultural ecosystem across art, community, education, and technology.
          </p>
          <div className="flex flex-wrap gap-x-8 gap-y-3 text-xs font-display font-bold uppercase tracking-widest">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" data-testid="footer-instagram" className="hover:text-[#FF1A1A] transition-colors inline-flex items-center gap-1">Instagram <ArrowUpRight size={12} /></a>
            <Link to="/contact" data-testid="footer-contact" className="hover:text-[#FF1A1A] transition-colors">Contact</Link>
            <Link to="/news" data-testid="footer-mediakit" className="hover:text-[#FF1A1A] transition-colors">Media Kit</Link>
            <Link to="/admin" data-testid="footer-admin" className="hover:text-[#FF1A1A] transition-colors">Admin</Link>
          </div>
        </div>
        <NewsletterBlock />
      </div>
      <div className="border-t border-border">
        <div className="container-x py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-muted-foreground font-mono-x uppercase tracking-widest">
          <span>© {year} Atuarra McCaslin</span>
          <span>Art · Community · Technology</span>
        </div>
      </div>
    </footer>
  );
}
